import { styled } from '@uhg-abyss/web/tools/styled';
import { Text } from '@uhg-abyss/web/ui/Text';

import { mobileOnly } from '../ConstantsStyles';

export const StyledText = styled(Text, {
  '&.abyss-text-root': {
    fontSize: '16px',
    [`@media ${mobileOnly}`]: {
      fontSize: '14px',
    },
    alignItems: 'center',
    display: 'flex',
    paddingRight: '4px',
    fontWeight: '500',
  },
});

export const compareSharePopoverStyles = {
  '&.abyss-popover-root': {
    backgroundColor: '#4B4D4F',
    width: '300px',
    borderWidth: '0px',
    marginLeft: '5px',
    borderRadius: '8px',
    '& svg': {
      fill: '#4B4D4F',
    },
    '.abyss-popover-close-button': {
      '& span': {
        backgroundColor: '#4B4D4F',
        color: '#FFFFFF',
        '&:hover, &focus': {
          backgroundColor: '#4B4D4F !important', // Keep hover background black
        },
      },
      '&:hover': {
        backgroundColor: 'transparent !important', // Transparent background on hover
      },
    },
    '.abyss-popover-content-container': {
      color: '#FFFFFF',
      fontSize: '14px',
      fontFamily: '$primary',
      fontWeight: '400px',
    },
    '.abyss-popover-title': {
      color: '#FFFFFF',
      fontSize: '18px',
      fontFamily: '$primary',
      fontWeight: '500px',
    },
  },
};

export const coachmarkPopoverStyles = {
  '.abyss-button-root': {
    color: '#4B4D4F',
    backgroundColor: '#FFFFFF',
    border: '1px solid #4B4D4F',
  },
  'abyss-popover-close-button': {
    boxShadow: 'none !important',
    '&:focus-visible': {
      border: '1px solid #FFFFFF',
    },
  },
  '.abyss-icon-symbol': {
    borderRadius: '25px',
    '&:focus-visible': {
      boxShadow: 'none',
    },
  },
};
